<template>
  <i8-modal :showClose="false" :title="$route.params.code">
    <div slot="i8-modal-body" v-t="$t(`${langRoot}.${$route.params.code}`)"></div>
    <div slot="i8-modal-footer">
      <div class="level">
        <div class="level-left">&nbsp;</div>
        <div class="level-right">
          <!-- Go back to root -->
          <div @click="$router.replace('/')" class="btn primary" v-t="$t(`${langRoot}.backBtn`)"></div>
        </div>
      </div>
    </div>
  </i8-modal>
</template>

<script>
const name = 'error-page';
import I8Modal from '@shared/components/I8Modal';
export default {
    name,
    componentName: name,
    components: {
        [I8Modal.name]: I8Modal,
    },
    data() {
        return {
            langRoot: 'errorPage',
        };
    },
};
</script>



// WEBPACK FOOTER //
// shared/components/ErrorPage.vue